const roles = {
  administrator: "Administrador",
  recruiter: "Recrutador",
  personal_department: "Departamento Pessoal",
  supervisor: "Supervisor de Estágio",
  representative: "Representante Legal",
  hr_business_partner: "HR Business Partner",
  financial: "Financeiro",
};

export const dashboardRoles = () => [
  roles.administrator,
  roles.representative,
  roles.financial,
  roles.recruiter,
  roles.hr_business_partner,
  roles.personal_department,
  roles.supervisor,
];

export const evaluationRoles = () => [
  roles.administrator,
  roles.supervisor,
  roles.personal_department,
];

export const candidateRoles = () => [
  roles.administrator,
  roles.recruiter,
];

export const eventsRoles = () => [
  roles.administrator,
  roles.representative,
  roles.hr_business_partner,
  roles.personal_department,
];

export const financialRoles = () => [
  roles.administrator,
  roles.financial,
];

export const portalRoles = () => [
  roles.administrator,
  roles.representative,
  roles.financial,
  roles.recruiter,
  roles.hr_business_partner,
  roles.supervisor,
  roles.personal_department,
];

export const contractsRoles = () => [
  roles.administrator,
  roles.representative,
  roles.hr_business_partner,
  roles.personal_department,
];

export const jobsRoles = () => [
  roles.administrator,
  roles.recruiter,
];

export const internshipRoles = () => [
  roles.administrator,
  roles.recruiter,
];

export const reportsRoles = () => [
  roles.administrator,
  roles.financial,
  roles.personal_department,
];

export const profileRoles = () => [
  roles.administrator,
  roles.representative,
  roles.financial,
  roles.recruiter,
  roles.hr_business_partner,
  roles.supervisor,
  roles.personal_department,
];

export const passwordRoles = () => [
  roles.administrator,
  roles.representative,
  roles.financial,
  roles.recruiter,
  roles.hr_business_partner,
  roles.supervisor,
  roles.personal_department,
];

export const collaboratorsRoles = () => [
  roles.administrator,
];

export const settingsRoles = () => [
  roles.administrator,
];

export const supportRoles = () => [
  roles.administrator,
  roles.representative,
  roles.financial,
  roles.recruiter,
  roles.hr_business_partner,
  roles.supervisor,
  roles.personal_department,
];

export const academyRoles = () => [
  roles.administrator,
];

export const interviewRoles = () => [
  roles.recruiter,
];

export const pendingRoles = () => [
  roles.personal_department,
];

export const questionnaireRoles = () => [
  roles.recruiter,
];

export const documentsRoles = () => [
  roles.personal_department,
];

export default roles;